export default __webpack_public_path__ + "static/media/Spring_s Genesis.2e143c16.png";